import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
    name: "phone",
    standalone: false
})

export class PipePhoneModule implements PipeTransform {
    transform(value: string) {
        if (!value) {
            return '';
        }

        let digits = value.replace(/\D/g, '')
        if ((digits.length < 10) || (digits.length > 13)) {
            return value;
        }

        if (digits.length == 10) {
            digits = '1' + digits;
        }

        let country = (digits.substring(0, digits.length - 10));
        let area = (digits.substring(digits.length - 10, digits.length - 10 + 3));
        let prefix = (digits.substring(digits.length - 7, digits.length - 7 + 3));
        let suffix = (digits.substring(digits.length - 4));

        return '+' + country + ' (' + area + ') ' + prefix + '-' + suffix;
    }
}

@Pipe({
    name: "safeUrl",
    standalone: false
})

export class SafeUrlPipe implements PipeTransform {
    constructor(private domSanitizer: DomSanitizer) {}
    transform(url) {
      return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
}
  
// if you want to add another pipe
// @Pipe({
//     name: "???",
// })
// export class PipeExample implements PipeTransform {
//     transform(value: string) {
//         var phone = ('' + value).replace(/\D/g, '');
//         var match = phone.match(/^(\d{3})(\d{3})(\d{4})$/);
//         if (match) {
//             return '(' + match[1] + ') ' + match[2] + '-' + match[3];
//         }
//         return value;
//     }
// }